import * as React from "react";
import "./SignedPdfItem.scss";
import { SignedPdfItem } from "./SignedPdfItem";
import { downloadSignedPdf } from "../../services/fileDownloader";

export const DigitalSignatureDocuments = ({ formattedSignedPdfList }) => {
    function downloadFile(documentId) {
        downloadSignedPdf(documentId, false).then(r => {
            return r;
        });
    }
    return (
        <div>
            {formattedSignedPdfList != null &&
                formattedSignedPdfList?.length > 0 &&
                formattedSignedPdfList?.map(x => (
                    <div style={{ width: "100%" }}>
                        <SignedPdfItem signedPdfObject={x} onDownload={downloadFile} />
                    </div>
                ))}
        </div>
    );
};
